import { Component, OnInit, Input, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MainService } from '../../services/main.service';

declare const window;

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  @ViewChild('collapseMenu') collapseMenu: ElementRef;
  slimMenu: boolean;
  showCollapseMenu: boolean;
  previousWindowHeight;
  previousScrollPosition: number;
  browser;

  constructor(public mainService: MainService) {
    this.previousScrollPosition = 0;
  }

  ngOnInit() {
    this.previousWindowHeight = window.innerHeight;
  }

  public onCollapse() {
    if (!this.showCollapseMenu) {
      if (window.innerWidth < 992) {
        this.collapseMenu.nativeElement.style.height = window.innerHeight + 'px';
      }
      this.showCollapseMenu = true;
    } else {
      this.showCollapseMenu = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  public onSlim(event) {
    if (window.innerWidth < 992) {
      this.collapseMenu.nativeElement.style.height = window.innerHeight + 'px';
      if (window.innerHeight !== this.previousWindowHeight) {
        this.collapseMenu.nativeElement.style.height = window.innerHeight + 'px';
        this.previousWindowHeight = window.innerHeight;
      }
    }
    if ((event as any).path !== undefined) {
      const scrollPosition = (event as any).path[1].pageYOffset;
      if (this.previousScrollPosition < scrollPosition) {
        if (!this.slimMenu) {
          if (scrollPosition > (window.innerHeight / 5)) {
            this.slimMenu = true;
          }
        }
      } else {
        if (scrollPosition < (window.innerHeight / 5)) {
          this.slimMenu = false;
        }
      }
      this.previousScrollPosition = (event as any).path[1].pageYOffset;
    } else if ((event as any).pageY) {
      const scrollPosition = (event as any).pageY;
      if (this.previousScrollPosition < scrollPosition) {
        if (!this.slimMenu) {
          if (scrollPosition > (window.innerHeight / 5)) {
            this.slimMenu = true;
          }
        }
      } else {
        if (scrollPosition < (window.innerHeight / 5)) {
          this.slimMenu = false;
        }
      }
      this.previousScrollPosition = (event as any).pageY;
    } else if (window.pageYOffset) {
      const scrollPosition = window.pageYOffset;
      if (this.previousScrollPosition < scrollPosition) {
        if (!this.slimMenu) {
          if (scrollPosition > (window.innerHeight / 5)) {
            this.slimMenu = true;
          }
        }
      } else {
        if (scrollPosition < (window.innerHeight / 5)) {
          this.slimMenu = false;
        }
      }
      this.previousScrollPosition = window.pageYOffset;
    }
  }
}
